import { render, staticRenderFns } from "./SelectProject.vue?vue&type=template&id=1b776f5e&scoped=true"
import script from "./SelectProject.vue?vue&type=script&lang=js"
export * from "./SelectProject.vue?vue&type=script&lang=js"
import style0 from "./SelectProject.vue?vue&type=style&index=0&id=1b776f5e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b776f5e",
  null
  
)

export default component.exports